import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const api = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "UserData",
    "UserProfile",
    "UserStats",
    "UserBalanceStatus",
    "UserWallets",
    "WithdrawalRequest",
    "SupportTickets",
    "Notifications",
    "WheelRaffle",
  ],
  endpoints: () => ({}),
});
